import React, { useEffect, useRef } from 'react';

import { FamlyEnquiryPanel } from '../components/sections/Contact/FamlyEnquiryPanel';
import { HeroSection } from '../components/sections/HeroSection';
import { generalMedia } from '../data/generalMedia';
import LocationCard from '../components/sections/Location/LocationCard';
import { RomfordLocation, TilburyLocation } from '../data/locations';
import GovernmentFundedSpaces from '../components/Common/GovernmentFundedSpaces';
import { pageView } from '../firebase/analytics';

/* helper to animate sections when they enter viewport */
const useSlideIn = () => {
  const ref = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.classList.add('opacity-0', 'translate-y-8');
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.remove('opacity-0', 'translate-y-8');
          el.classList.add('opacity-100', 'translate-y-0', 'transition', 'duration-700');
          io.disconnect();
        }
      },
      { threshold: 0.2 },
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return ref;
};

export default function ContactPage() {
  const bg = generalMedia['hero-section'];
  const formRef = useSlideIn();
  const mapRef  = useSlideIn();

  pageView('/contact');

  return (
    <div className="overflow-x-hidden">
      <HeroSection
        title="Get in touch"
        subtitle="We’d love to hear from you. Start an enquiry below, or call, WhatsApp or email us directly."
        backgroundImage={bg.src}
      />

      <GovernmentFundedSpaces
        title="Government Funded Hours"
        highlight="FREE of charge to parents*!"
        footnote="*Additional costs only apply if parents choose meals or other consumables."
        accent="green"          // "red" | "yellow" | "blue" | "pink" | "green" | "orange"
        periodicAttention       // keep subtle glow
        shimmerHeading          // keep shimmer
        aos="fade-up"           // uses AOS on scroll
      />

      <section
        ref={formRef}
        className="max-w-6xl mx-auto px-4 py-16 opacity-0 translate-y-8"
      >
        <FamlyEnquiryPanel />
      </section>

      <section
        ref={mapRef}
        className="max-w-6xl mx-auto px-4 pb-16 flex flex-col md:flex-row gap-8 opacity-0 translate-y-8"
      >
        <div className="flex flex-col gap-4 md:flex-row">
          <div className="flex-1">
            <LocationCard {...RomfordLocation} />
          </div>
          <div className="flex-1">
            <LocationCard {...TilburyLocation} />
          </div>
        </div>
      </section>
    </div>
  );
}
